// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import {combineReducers} from 'redux';
import {ActionTypes} from 'utils/constants.jsx';
import {UserTypes} from 'mattermost-redux/action_types';

function previousMainState(state = null, action) {
    switch (action.type) {
    case ActionTypes.UPDATE_MAIN_STATE:
        if (action.previousMainState) {
            return action.previousMainState;
        }
        return null;
    case UserTypes.LOGOUT_SUCCESS:
        return null;
    default:
        return state;
    }
}

function mainState(state = 1, action) {
    switch (action.type) {
    case ActionTypes.UPDATE_MAIN_STATE:
        if (action.state != undefined) {
            return action.state;
        }
        return state;
    case UserTypes.LOGOUT_SUCCESS:
        return 1;
    default:
        return state;
    }
}

function theme(state = "boomea", action) {
    switch (action.type) {
    case ActionTypes.STORE_SITE_THEME:
         return action.data;
    default:
        return state;
    }
}

export default combineReducers({
    previousMainState,
    mainState,
    theme,
});
